module.exports = __webpack_public_path__ + "static/media/Test13.5420c8e2.bmp";